import { ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import LoadingButton from 'components/@extended/LoadingButton';
import TrackedButton, { TrackedButtonProps } from '../TrackedButton';

const StyledButton = styled(TrackedButton)<TrackedButtonProps>(() => ({
  borderRadius: 4,
  backgroundColor: '#004A6F'
}));

export { StyledButton };

const StyledLodingButton = styled(LoadingButton)<ButtonProps>(() => ({
  borderRadius: 4,
  backgroundColor: '#004A6F'
}));

export { StyledLodingButton };
